export const transformLocaleToLanguageCode = (locale: string): string => locale.trim().toLowerCase().split('-')[0];
